/* global G */

/**
 * Recreate Hook
 *
 * Forces the current module's ui to be created again.
 *
 * @param {Object} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const recreate = obj => async (...args) => {
  obj[G.ADAPTER][G.UI].create(obj)
  return args
}

export default recreate
